// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1___9d700277c9bb8fd423a","cls2":"SimplePaperPodcast-cls2___ec47e1de00b1c3afb38 SimplePaperPodcast-cls1___9d700277c9bb8fd423a"};